import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { FaUserNurse, FaUsers, FaUserShield, FaChevronRight } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import "../../styles/newLogin.css";

const ROLE_META = {
  CAREGIVER: { label: "Caregiver", Icon: FaUserNurse },
  FAMILYMEMBER: { label: "Family Member", Icon: FaUsers },
  ADMIN: { label: "Administrator", Icon: FaUserShield },
};

const describeRole = (role) => ROLE_META[role] || { label: role, Icon: FaUsers };

/**
 * Popup shown when an email is registered under more than one role, so the
 * user can pick which account's password reset to continue with.
 */
const RoleSelectDialog = ({ open, roles = [], onSelect, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    aria-labelledby="role-select-dialog-title"
    PaperProps={{ sx: { borderRadius: "20px", margin: "16px" } }}>
    <DialogContent sx={{ position: "relative", padding: "40px 24px 28px", textAlign: "center" }}>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          borderRadius: "50%",
          background: "#f5efe6",
          color: "#6b5b4d",
          fontSize: 18,
          cursor: "pointer",
        }}>
        <IoClose />
      </button>

      <h2 id="role-select-dialog-title" style={{ margin: "0 0 8px", fontSize: 20, fontWeight: 700, color: "#dd8f1d" }}>
        Choose your role
      </h2>
      <p style={{ margin: "0 0 22px", fontSize: 14, lineHeight: 1.5, color: "#6b7280" }}>This email is registered for more than one role. Select which one to reset the password for.</p>

      <div className="nl-login-role-list" role="group" aria-label="Select a role">
        {roles.map((role) => {
          const { label, Icon } = describeRole(role);
          return (
            <button key={role} type="button" className="nl-login-role-option" onClick={() => onSelect(role)}>
              <span className="nl-login-role-icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="nl-login-role-text">
                <span className="nl-login-role-label">{label}</span>
              </span>
              <FaChevronRight size={13} className="nl-login-role-chevron" aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);

export default RoleSelectDialog;
